import React from "react";

type ClassName = string;
type ModalHeaderProps = {
  divide?: boolean;
  className?: ClassName;
};
const ModalHeader: React.FC<ModalHeaderProps> = ({
  children,
  divide,
  className = "",
}) => (
  <section className={`txu-header${divide ? " txu-divide" : ""} ${className}`}>
    {children}
  </section>
);
type ModalBodyProps = {
  className?: ClassName;
  minHeight?: number; // px
};
const ModalBody: React.FC<ModalBodyProps> = ({
  children,
  minHeight,
  className = "",
}) => (
  <section
    className={`txu-body ${className}`}
    {...(minHeight && { style: { minHeight: `${minHeight}px` } })}
  >
    {children}
  </section>
);

const ModalActions: React.FC = ({ children }) => (
  <section className="txu-actions">{children}</section>
);

type Props = {
  dialogRef: React.RefObject<HTMLDialogElement>;
  isLoading?: boolean;
  size?: "sm" | "lg" | "full";
  className?: ClassName;
  contentClassName?: ClassName;
};

type ModalType = React.FC<Props> & {
  Header: React.FC<ModalHeaderProps>;
  Body: React.FC<ModalBodyProps>;
  Actions: React.FC;
};
const Modal: ModalType = ({
  children,
  dialogRef,
  isLoading,
  size,
  className = "",
  contentClassName = "",
}) => {
  let classNames = "txu-modal";
  if (size) {
    classNames += ` txu-${size}`;
  }
  if (isLoading) {
    classNames += " txu-loading";
  }
  if (className) {
    classNames += ` ${className}`;
  }
  return (
    <dialog ref={dialogRef} className={classNames}>
      <div className={`txu-content ${contentClassName}`}>{children}</div>
    </dialog>
  );
};

Modal.Header = ModalHeader;
Modal.Body = ModalBody;
Modal.Actions = ModalActions;

export { Modal };
